export default __webpack_public_path__ + "be52848bed33e0636083b1adee2ccabf.png";